module.exports = __webpack_public_path__ + "img/pre-build-models.934ac317.svg";